/**
 * @file
 * Handle the common map.
 */

(function ($) {
  "use strict";

  Drupal.behaviors.slideout = {
    attach: function (context, settings) {

      var width = Math.min($( window ).width() - 65, 320);

      var slideout = new Slideout({
        'panel': $('.page').get(0),
        'menu': $('.slideout').get(0),
        'padding': width,
        'tolerance': 70,
        'side': 'right',
        'touch': false
      });

      $('.js-slideout-btn', context).on('click', function() {
        slideout.toggle();
        $( ".slideout" ).width(width);
        return false;
      });

      $('.slideout-panel').on('click', function() {
        if (slideout.isOpen()) {
          slideout.close();
        }
      })
    }
  };

})(jQuery);
